class UserController {
  /* @ngInject */
  constructor(
    $scope,
    $log,
    $stateParams,
    $filter,
    $state,
    $interval,
    Users,
    ngDialog,
    toastr,
    LoggedInUserStore,
    snackBar,
  ) {
    Object.assign(this, {
      $scope,
      $log,
      $stateParams,
      $filter,
      $state,
      $interval,
      Users,
      ngDialog,
      toastr,
      LoggedInUserStore,
      snackBar,
      canToggleTest: false,
    });
    $scope.$on('select-tab:payment-methods', () => {
      this.activeTab = 2;
    });
    this.activeTab = 0;
    this.load();
  }

  load() {
    this.Users.getOne(this.$stateParams.id)
      .then(({ data }) => {
        this.user = data; // Need to set Date of Birth to UTC as they are stored in British time

        this.user.dob = this.$filter('date')(this.user.dob, 'dd/MMM/yyyy', 'UTC');
        this.$log.debug('User: ', this.user);
      })
      .catch(() => (this.error = true));
    this.canToggleTest = this.checkUserForTogglingTest();
  }

  toggleTest() {
    this.Users.toggleTest(this.user.id, !this.user.type.test)
      .then(() => {
        this.user.type.test = !this.user.type.test;
        this.snackBar.openSuccessMessage(
          `Patient's account is now set to ${this.user.type.test ? 'Test' : 'Live'}`,
          3000,
        );
      })
      .catch(err => this.$log.error(err));
  }

  updateStatus() {
    let locked = this.user.status === 1 ? true : false,
      statuses = ['USER_LOCKED', 'USER_LOCKED_LOGIN'];

    _.each(statuses, status => {
      this.Users.updateStatus(this.user.id, status, locked)
        .then(({ data }) => (this.user = data))
        .catch(err => this.$log.error(err));
    });
  }

  closeAccount() {
    this.Users.closeUserAccount(this.user.id)
      .then(() => {
        this.load();
        this.toastr.success("Patient's account is closed");
      })
      .catch(err => {
        this.toastr.error("Could not close patient's account.");
      });
  }

  checkFinish() {
    if (this.num_processed >= this.num_to_process) {
      if (this.poll) this.$interval.cancel(this.poll);
      if (!this.error_processing) this.closeAccount();
    }
  }

  confirmCloseAccount() {
    const config = {
      template: 'app/components/modals/confirm.tpl.html',
      data: {
        title: 'Close User account',
        content: 'Are you sure you want to close this User account?',
      },
    };
    this.ngDialog.openConfirm(config).then(() => {
      // SPRINT 117
      // WE DECIDED TO REVERT CHANGES ON CANCELING SUBSCRIPTIONS WHEN CLOSING ACCOUNTS
      this.closeAccount();
    });
  }

  isStorePortalUser() {
    return !!(this.user.roles['22'] || this.user.roles['23'] || this.user.roles['24']);
  }

  checkUserForTogglingTest() {
    const allowedRoles = [this.Users.ROLES.SUPER.NAME, this.Users.ROLES.QA_USER.NAME];
    const currentClinicianRoles = Object.values(this.LoggedInUserStore.user().roles);
    return allowedRoles.some(el => currentClinicianRoles.includes(el));
  }
}

UserController.$inject = [
  '$scope',
  '$log',
  '$stateParams',
  '$filter',
  '$state',
  '$interval',
  'Users',
  'ngDialog',
  'toastr',
  'LoggedInUserStore',
  'snackBar',
];
angular.module('pims').controller('UserController', UserController);
